import translit from "cyrillic-to-translit-js";

export const categorysTable = [
  {
    value: "id",
    name: "ID",
    editable: false,
    component: "VTextField",
    size: "sm",
    validator: (value) => {
      return value;
    },
    onInput: () => {},
    length: "",
  },
  {
    value: "alias",
    name: "Alias",
    editable: true,
    component: "VTextField",
    size: "sm",
    type: "varchar",
    length: "100",
    validator() {
      return true;
    },
    onInput() {},
  },
  {
    value: "sort",
    name: "Сортировка",
    editable: true,
    component: "VTextField",
    length: "",
    size: "sm",
    validator: () => {
      return true;
    },
    onInput: () => {},
  },
  {
    value: "type",
    name: "Тип",
    editable: true,
    size: "sm",
    length: "",
    component: "VTextField",
    selectBox: false,
    selectComponent: "VTreeview",
    selectLoadedData: [],
    validator: (value) => {
      return value;
    },
    onInput: () => {},
  },
  {
    value: "brend_id",
    name: "Бренд",
    editable: true,
    size: "sm",
    length: "",
    component: "VTextField",
    selectBox: false,
    selectComponent: "VTreeview",
    selectLoadedData: [],
    validator: (value) => {
      return value;
    },
    onInput: () => {},
  },
  {
    value: "serie_id",
    name: "Серия",
    editable: true,
    size: "sm",
    length: "",
    component: "VTextField",
    selectBox: false,
    selectComponent: "VTreeview",
    selectLoadedData: [],
    validator: (value) => {
      return value;
    },
    onInput: () => {},
  },
  {
    value: "title",
    name: "Название",
    editable: true,
    component: "VTextField",
    size: "md",
    type: "varchar",
    length: "100",
    style: {
      fontSize: "19px",
      fontWeight: 500,
      color: "grey",
    },
    validator: (value) => {
      return value;
    },
    onInput() {
      this.editingObject.alias = translit({ preset: "ru" })
        .transform(this.editingObject.title_ru, "_")
        .toLowerCase();

      //   translate("ru-uk", this.editingObject.title_ru).then(({ data }) => {
      //     this.editingObject.title_ua = data;
      //   });
    },
  },
  {
    value: "title_ru",
    name: "Название (рус.)",
    editable: true,
    component: "VTextField",
    size: "md",
    type: "varchar",
    length: "100",
    style: {
      fontSize: "19px",
      fontWeight: 500,
      color: "grey",
    },
    validator: (value) => {
      return value;
    },
    onInput() {
      this.editingObject.alias = translit({ preset: "ru" })
        .transform(this.editingObject.title_ru, "_")
        .toLowerCase();

      //   translate("ru-uk", this.editingObject.title_ru).then(({ data }) => {
      //     this.editingObject.title_ua = data;
      //   });
    },
  },
  {
    value: "title_ua",
    name: "Название (укр.)",
    editable: true,
    component: "VTextField",
    size: "md",
    type: "varchar",
    length: "100",
    style: {
      fontSize: "19px",
      fontWeight: 500,
      color: "grey",
    },
    validator: (value) => {
      return value;
    },
    onInput: () => {},
  },
  {
    value: "title_full",
    name: "Полное название",
    editable: true,
    component: "VTextField",
    size: "md",
    type: "varchar",
    length: "100",
    style: {
      fontSize: "19px",
      fontWeight: 500,
      color: "grey",
    },
    validator: (value) => {
      return value;
    },
    onInput: () => {},
  },
  {
    value: "publish",
    name: "Публикация",
    editable: true,
    component: "VCheckbox",
    type: "tinyint",
    length: "",
    size: "sm",
    validator: (value) => {
      return value;
    },
    onInput: () => {},
  },
];
